import IconBox from '@/components/iconBox';
import { CustomSelectCompany } from '@/modules/company/components';
import { Company } from '@/modules/company/entities/interfaces/company';
import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import ICONS from '@/shared/entities/constants/icons';
import storage from '@/utils/storage/storage';
import React from 'react';
import { Text } from 'vkit/lib/components';
import { Box, Grid, Row } from 'vkit/lib/context';

interface RecentCompaniesProps {
  onClick: (company: Company) => void;
}

const RecentCompanies: React.FC<RecentCompaniesProps> = ({ onClick }) => {
  const { user } = useCurrentUser();
  const { isBrokerUser } = useCurrentUser();
  const recentCompanies = storage.get<Company[]>(`${user.id}.recentCompanies`) ?? [];

  const validateRecentCompanies = (company: Company) => {
    const fiedlKeys: Partial<keyof Company>[] = [
      'id',
      'name',
      'companyGroupId',
      'salesforceId',
      'status',
    ];

    return fiedlKeys.every(
      (fieldKey) =>
        company[fieldKey] !== undefined && company[fieldKey] !== null && company[fieldKey] !== '',
    );
  };

  return recentCompanies?.length ? (
    <Grid column gap={16} stretch>
      <Text value='Recentes' size='medium' />
      {recentCompanies.filter(validateRecentCompanies).map((recentCompany) => (
        <Box key={recentCompany.id} rounded type='sheet' onClick={() => onClick(recentCompany)}>
          <Row>
            <Grid row alignItems='center' gap={16}>
              <IconBox icon={ICONS.COMPANY} size={40} />
              <CustomSelectCompany showCompanyStatus={isBrokerUser} option={recentCompany} />
            </Grid>
          </Row>
        </Box>
      ))}
    </Grid>
  ) : null;
};

export default RecentCompanies;
